export default {
  machine: {
    EmptyName: {
      en: "Unnamed",
      pt: "Sem nome",
    },
  },
};
